module.exports = __webpack_public_path__ + "img/5.cf9b324a.png";